import './style.scss'

import React from 'react'

import DotIcon from '~/assets/images/icons/dot.svg?react'
import ArrowIcon from '~/assets/images/icons/right-arrow.svg?react'
import { Button } from '~/components/buttons'
import { TableTooltip } from '~/components/UI/tooltip/TableTooltip'
import { getRangeDateFormatGrouped } from '~/helpers/get-date-format'

import { getPublicEmptyLegCapacity, getPublicEmptyLegType } from '../../domain/presentation'
import { PublicEmptyLeg } from '../../domain/types'

type PublicEmptyLegCardProps = {
    emptyLeg: PublicEmptyLeg
    isExactMatch?: boolean
    onGetInfo: () => void
}

export const PublicEmptyLegCard = ({
    emptyLeg,
    isExactMatch = false,
    onGetInfo,
}: PublicEmptyLegCardProps) => {
    const type = getPublicEmptyLegType(emptyLeg.requestType)
    const aircraftModel = emptyLeg.aircraftModel || emptyLeg.aircraft?.model

    return (
        <article className="public-empty-legs__card">
            <div className={`public-empty-legs__type ${type === 'Ad hoc' ? 'public-empty-legs__type_ad-hoc' : ''}`}>
                <span className="public-empty-legs__type-text">{type}</span>
            </div>
            <div className="public-empty-legs__info">
                {isExactMatch && (
                    <span className="public-empty-legs__exact-match">Exact match</span>
                )}
                <div className="public-empty-legs__top">
                    <TableTooltip text={emptyLeg.fromText}>
                        <span className="public-empty-legs__airport">{emptyLeg.fromIata_code || emptyLeg.fromIcao_code}</span>
                    </TableTooltip>
                    <ArrowIcon className="public-empty-legs__arrow" />
                    <TableTooltip text={emptyLeg.destinationText}>
                        <span className="public-empty-legs__airport">{emptyLeg.destinationIata_code || emptyLeg.destinationIcao_code}</span>
                    </TableTooltip>
                    {aircraftModel && (
                        <>
                            <DotIcon className="public-empty-legs__dot" />
                            <span className="public-empty-legs__aircraft-model">{aircraftModel}</span>
                        </>
                    )}
                </div>
                <div className="public-empty-legs__bottom">
                    <span className="public-empty-legs__text">{getPublicEmptyLegCapacity(emptyLeg)}</span>
                    <DotIcon className="public-empty-legs__dot" />
                    <span className="public-empty-legs__text">{getRangeDateFormatGrouped(emptyLeg.startDate, emptyLeg.endDate)}</span>
                </div>
            </div>
            <div className="public-empty-legs__button">
                <Button text="Get info" onClick={onGetInfo} />
            </div>
        </article>
    )
}
